import Cookies from 'js-cookie';

/**
 * Minimal cookie accessor, works both client- and server-side.
 */
export interface CookieStore {
  get(name: string): string | undefined;
}

/**
 * Client-side cookies (backed by `document.cookie`).
 */
export const getClientSideCookies = (): CookieStore => {
  return Cookies;
};

/**
 * Server-side cookies (wraps `request.cookies`) in a common interface.
 */
export const getRequestCookies = (request: {
  cookies?: Partial<Record<string, string>>;
}): CookieStore => ({
  get: (name: string) => request.cookies?.[name],
});
